import { IMG } from "../content";
import { Reveal } from "./Reveal";

const Mindset = () => (
  <section className="mindset section-pad" data-testid="mindset-section">
    <div className="mindset-grid">
      <div className="mindset-frames">
        <Reveal className="mindset-frame">
          <img src={IMG.mindsetWall} alt="Mindset Is Everything lettering on the gym wall" loading="lazy" />
        </Reveal>
        <Reveal delay={0.2} className="mindset-subframe">
          <img src={IMG.meditation} alt="Athletes seated in meditation during a Mindful Athlete session" loading="lazy" />
        </Reveal>
      </div>
      <Reveal delay={0.15} className="mindset-copy">
        <p className="eyebrow" data-testid="mindset-eyebrow">The foundation</p>
        <h2 className="section-heading">Mindset Is Everything</h2>
        <p className="statement">Mental performance is <em>part of performance.</em></p>
        <p className="body-copy">
          We help athletes strengthen confidence, manage pressure, build resilience and develop practical mental tools
          they can use in training, competition and everyday life.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Mindset;
